import Code from './Code';

export default Code;
